<template>
  
    <div class="flex flex-row text-black text-xl rounded">

        <div v-if="showTime">

            <div>

                <div class="myPitchTimeSlotGreenText" v-if="index % 2 == 0">

                    <label>{{time}}</label>
                </div>

                <div class="myPitchTimeSlotLightGreenText" v-else>

                    <label>{{time}}</label>
                </div>
            </div>
        </div>
        <div v-else>

            <div>

                <div class="myPitchTimeSlotLightGrayText" v-if="index % 2 == 0" >

                    <label>{{time}}</label>
                </div>

                <div class="myPitchTimeSlotLightGrayText" v-else>

                    <label>{{time}}</label>
                </div>
            </div>
        </div>
  </div>

</template>

<script>

import componentsHelpers from '../../classes/componentHelpers';

import moment from 'moment';
export default {

    mounted(){

        // console.log(`time is: ${this.time}`);
        // console.log(`endTime is: ${this.endTime}`);
    },

    props:{
        
        index: 0,

        time: '',

        endTime: '',

        dayDate:'',
        
        mySlot:{

            type: Object
        },

        showTime: true,

        addBookingTime: {

            type: Function
        },

        removeBookingTime: {

            type: Function
        }
    },

    computed:{
        
    },

    methods:{

        // notBookable(){

        //     componentsHelpers.toastIt(this.$toasted, this.$t('pitch.notBookable'), 3, 'outline', true)
        // },

        // bookable(){

        //     // console.log(`inside bookable`);

        //     if(this.clicked == false){

        //         this.clicked = true;
        //         this.addBookingTime(this.time, this.mySlot.id, this.clearClicked);
        //     }else{

        //         this.clicked = false;

        //         this.removeBookingTime(this.time, this.mySlot.id);
        //     }
        // },

        clearClicked(){

            this.clicked = false;
        }
    },

    data: function(){

        return{

            clicked: false,
        }
    }

}
</script>

<style>

</style>